import { useEffect, useRef, useState } from "react";
import { Info } from "@phosphor-icons/react";

export function FieldHint({ text, testId }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <span className="relative inline-block ml-1" ref={ref}>
      <button
        type="button"
        data-testid={testId || "field-hint-trigger"}
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen((o) => !o); }}
        title={text}
        className="text-igc-muted hover:text-igc-goldText transition-colors align-middle"
      >
        <Info size={13} weight="duotone" />
      </button>
      {open && (
        <span
          data-testid={`${testId || "field-hint"}-content`}
          className="absolute left-0 top-5 z-50 w-56 bg-igc-surfaceLight border border-igc-gold/30 text-igc-cream text-xs leading-relaxed p-2.5 shadow-2xl"
        >
          {text}
        </span>
      )}
    </span>
  );
}

export function FieldLabel({ children, hint, testId, className = "" }) {
  return (
    <span className={`inline-flex items-center text-igc-muted text-[10px] uppercase tracking-widest ${className}`}>
      {children}
      {hint && <FieldHint text={hint} testId={testId} />}
    </span>
  );
}
